<template>
   <div class="setting-preferences">
     <SettingsBlock title="Timestamp">
      <p class="subtitle">Toggle the ‘Show Speaker Timestamp’ option to display
      or hide timestamps for each speaker’s diarization in the transcript.</p>
      <div class="toggle-wrapper">  
        <p> Show Speaker Timestamp</p>
        <ToggleSwitch v-model="showTimestamps" />
      </div>
     </SettingsBlock>
   </div>
 </template>
 
<script setup lang="ts">
import SettingsBlock from './SettingsBlock.vue';
import { ref } from 'vue';

const showTimestamps = ref(false);
</script>
<style lang="scss" scoped>
.setting-preferences {
  font-family: $font-secondary;
  .subtitle {
    color: map-get($colours, grey-3);
    margin-top: 0.8rem;
    // font-family: $font-secondary;
    font-size: 1.2rem;
  }
  .toggle-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

  }

}
</style>
 